import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { Organization as OrganizationType } from "@/types/org";
import { Styled } from "./styles";
import { Role } from "@/types/user";

interface Props {
    data: [
        string,
        {
            role: Role;
            organization: Omit<OrganizationType, "id">;
        },
    ];
    isSelected?: boolean;
    onSelect: (oid: string) => Promise<void>;
    cardStyle?: React.CSSProperties | undefined;
    textStyle?: React.CSSProperties | undefined;
    iconStyle?: React.CSSProperties | undefined;
}

const Organization: React.FC<Props> = ({
    data,
    isSelected,
    onSelect,
    cardStyle,
    textStyle,
    iconStyle,
}) => {
    const theme = useTheme();
    const {
        organization: { name },
        role,
    } = data[1];
    const oid = data[0];

    const color = isSelected ? theme.palette.common.white : theme.palette.common.black;

    return (
        <Styled.ListItem style={cardStyle} isSelected={isSelected} onClick={() => onSelect(oid)}>
            <Box display="flex" alignItems="center" gap="15px">
                <PersonIcon sx={{ color, ...iconStyle }} />
                <Typography color={color} sx={textStyle} variant="h4">
                    {role}
                </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap="15px">
                <AccountBalanceIcon sx={{ color, ...iconStyle }} />
                <Typography color={color} sx={textStyle} variant="h6">
                    {name}
                </Typography>
            </Box>
        </Styled.ListItem>
    );
};

export default Organization;
